/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as VerificationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.verification.listVerifications'

export { $nsid }

/** List verifications */
const main = l.query(
  $nsid,
  l.params({
    cursor: l.optional(l.string()),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    createdAfter: l.optional(l.string({ format: 'datetime' })),
    createdBefore: l.optional(l.string({ format: 'datetime' })),
    issuers: l.optional(
      l.array(l.string({ format: 'did' }), { maxLength: 100 }),
    ),
    subjects: l.optional(
      l.array(l.string({ format: 'did' }), { maxLength: 100 }),
    ),
    sortDirection: l.optional(l.withDefault(l.enum(['asc', 'desc']), 'desc')),
    isRevoked: l.optional(l.boolean()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    verifications: l.array(
      l.ref<VerificationDefs.VerificationView>(
        (() => VerificationDefs.verificationView) as any,
      ),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
